import styled from "styled-components";
import { mediaMaxWidth } from "../../utils/mediaQueriesTemplate";

export const FiltersWrapper = styled.div`
  padding-left: 20px;
`;

export const Wrapper = styled.div`
  position: relative;
`;

export const Filter = styled.div`
  position: relative;
  color: #333;
  display: flex;
  align-items: center;

  .fa-calendar {
    position: relative;
    color: #565656;
  }
`;

export const DatePickerWrapper = styled.div`
  border-radius: 4px;

  .CalendarMonth_table {
    width: 100%;
  }
  .DateRangePicker {
    tr td:first-child {
      min-width: unset;
    }

    .DateRangePickerInput {
      padding: 0 5px;
      height: 24px;
      background: transparent;
      display: flex;
      align-items: center;
      gap: 10px;
    }

    .DateInput {
      height: 22px;
      width: 115px;
    }

    .DateInput_input {
      height: 22px;
      padding: 0 0 0 0;
      font-size: 0.92em;
      font-weight: 700;
      text-align: center;
      color: #565656;
      cursor: pointer;
      border: 1px solid #e8e5ee;
      background: transparent;

      &::-webkit-input-placeholder {
        color: #565656;
      }

      &:-ms-input-placeholder {
        color: #565656;
      }

      &::placeholder {
        color: #565656;
      }
    }
    .DateRangePicker_picker div {
      width: 100% !important;
      left: 0;
    }

    .DateRangePicker_picker {
      top: 42px !important;
      border-radius: 0px;
      left: -54px !important;
      width: 500px;

      ${mediaMaxWidth.tablet`
        top: 70px !important;
        border-radius: 0px;
        width: calc(100vw - 32px);
        height: fit-content;
      `}
    }

    .DateInput_fang {
      display: none;
      top: 21px !important;
    }

    .DayPicker {
      border-radius: 4px;
      overflow: hidden;

      ${mediaMaxWidth.tablet`
        border-radius: 0;
        box-shadow: none;
      `}
    }

    .DayPickerNavigation_button {
      .fa-chevron-circle-left {
        color: #79D9D9;
        font-size: 1.5em;
        position: absolute;
        left: 20px;
        top: 20px;
      }

      .fa-chevron-circle-right {
        color: #79D9D9;
        font-size: 1.5em;
        position: absolute;
        right: 20px;
        top: 20px;
      }
    }

    .DateRangePicker_picker .DayPicker_weekHeader {
      top: 56px;
      width: 68px !important;
      padding: 0 !important;

      ${mediaMaxWidth.tablet`
        top: 45px;
        width: calc(100% - 22px)!important;
        padding: 0 !important;
      `}
    }

    .DateRangePicker_picker .DayPicker_weekHeader_li {
      width: 68px !important;
      padding: 0;
      ${mediaMaxWidth.tablet`
      width: 51px!important;`}
    }

    .CalendarMonth_caption {
      font-size: 0.94em;

      ${mediaMaxWidth.tablet`
        padding-bottom: 21px;
      `}
    }

    .CalendarDay__default:hover {
      background: #8364b9;
      border: 1px double #fff;
      color: #fff;
    }

    .CalendarDay__selected,
    .CalendarDay__selected:active,
    .CalendarDay__selected:hover {
      background: #402680;
      border: 1px double #fff;
    }

    .CalendarDay__hovered_span,
    .CalendarDay__hovered:hover {
      background: #8f65d8;
      border: 1px double #fff;
      color: #fff;
    }

    .CalendarDay__selected_span {
      background: #8364b9;
      border: 1px double #fff;
    }

    .DateRangePickerInput_clearDates {
      right: -30px;
      top: auto;
      border-radius: 50%;
      height: 22px;
      width: 22px;
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 0;
      margin: 0px;
      transform: none;
      svg {
        fill: #333;
      }
    }

    .DateRangePickerInput_clearDates_default:focus,
    .DateRangePickerInput_clearDates_default:hover {
      background: none;

      svg {
        fill: #79D9D9;
      }
    }
  }
`;

export const FilterTriggerWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
`;

export const FilterTrigger = styled.div`
  font-weight: 700;
  cursor: pointer;
  text-transform: capitalize;
  display: flex;

  svg.fa-filter {
    margin-right: 10px;
    color: #565656;
    position: relative;
    display: ${(props) => props.selected && "none"};
  }
`;

export const FilterTriggerInner = styled.div`
  background-color: ${(props) => props.selected && "#79D9D9"};
  color: ${(props) => props.selected && "#fff"};
  padding: 2px 10px;
  font-size: 0.94em;
  border-top-left-radius: 20px;
  border-bottom-left-radius: 20px;
  position: relative;
`;

export const Header = styled.div`
  position: absolute;
  font-size: 0.8em;
  color: #565656;
  top: 5px;
  border-bottom: 1px solid rgb(216, 216, 216);
  display: flex;
  flex: 1;
  width: calc(100% - 20px);
  margin: 0 5px;
  padding: 3px 7.5px;
  font-weight: 600;

  ${mediaMaxWidth.tablet`
    font-size: 1em;
    width: calc(100vw - 20px);
    padding: 5px 7.5px;
  `}

  ${mediaMaxWidth.smallPhone`
    font-size: 0.9em;
  `}
`;

export const CloseButton = styled.div`
  position: absolute;
  font-size: 0.9em;
  top: 6px;
  right: 17.5px;
  cursor: pointer;

  svg {
    transition: 0.1s ease-in-out;
  }

  &:hover {
    svg {
      color: #79D9D9;
    }
  }

  ${mediaMaxWidth.tablet`
    top: 6px;
    font-size: 1.4em;
  `}

  ${mediaMaxWidth.smallPhone`
    top: 7px;
    font-size: 1.2em;
  `}
`;

export const FilterOption = styled.div`
  cursor: pointer;
  padding: ${(props) =>
    props.selected ? "5px 35px 5px 10px" : "5px 5px 5px 10px"};
  border-radius: 4px;
  text-transform: capitalize;
  position: relative;
  color: #565656;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 195px;
  display: block;
  margin: 2.5px;

  svg {
    position: absolute;
    right: 8px;
    top: 9px;
    font-size: 0.8em;
  }

  &:hover {
    background-color: #79D9D9;
    color: #fff;
  }

  ${mediaMaxWidth.tablet`
    font-size: 1.5em;
    width: calc(100vw - 15px);
    padding: ${(props) =>
      props.selected ? "5px 45px 5px 10px" : "5px 10px 5px 10px"};

    &:hover {
      background-color: #fff;
      color: #565656;
    }
  `}

  ${mediaMaxWidth.smallPhone`
    font-size: 1.35em;
  `}
`;

export const ResetSingleFilter = styled.div`
  position: relative;
  top: 2px;

  svg.fa-times {
    cursor: pointer;
    z-index: 5;
    background-color: #79D9D9;
    padding: 4px 0px;
    height: 25px;
    color: #fff;
    width: 25px;
    border-top-right-radius: 20px;
    border-bottom-right-radius: 20px;
    position: relative;
  }
`;

export const MobileCloseBtn = styled.div`
  position: fixed;
  right: 8px;
  top: 5px;
  text-decoration: underline;
`;

export const Sorting = styled.div`
  margin: 5px 0px 5px;
  label {
    padding-left: 20px;
  }
`;
